import styled from 'styled-components';
import colors from '@honeybook/hbui/dist/styles/colors';

export const FormContainer = styled.form`
    display: flex;
    flex-direction: column;
    background: ${colors.white};
    padding: 40px;
    align-items: center;
`;

export const InputContainer = styled.div`
    display: flex;
    align-items: center;
    width: 500px;
    gap: 30px;
`;
